import React, { useEffect, useState } from 'react'
import './ChatMessage.sass'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition, faEnvelope, faLink, faPhone } from '@fortawesome/free-solid-svg-icons'

export interface SmartLink {
    label: string
    link: string
    type: string
}

interface Props {
    smartLink: SmartLink
    index: number
}

const LinkBubble: React.FC<Props> = (props) => {
    const [isVisible, setIsVisible] = useState(false)
    const [icon, setIcon] = useState<IconDefinition>(faLink)
    useEffect(() => {
        switch (props.smartLink.type) {
            case 'mail':
                setIcon(faEnvelope)
                break
            case 'url':
                setIcon(faLink)
                break
            case 'phone':
                setIcon(faPhone)
                break
            default:
                break
        }
        setTimeout(() => {
            setIsVisible(true)
        }, (props.index + 1) * 250)
    }, [])

    return (
        <a
            className={`link-bubble ${isVisible ? 'link-bubble-visible' : 'link-bubble-not-visible'}`}
            href={props.smartLink.link}
            target="_blank"
            rel="noopener noreferrer"
        >
            <div className="link-bubble__icon">
                <FontAwesomeIcon icon={icon} />
            </div>

            {props.smartLink.label}
        </a>
    )
}

export default LinkBubble
